module.exports = __webpack_public_path__ + "img/case-知味观.d998dfbf.png";